import { render } from "./ShortPlanBox.vue?vue&type=template&id=315ea471&scoped=true"
import script from "./ShortPlanBox.vue?vue&type=script&lang=js"
export * from "./ShortPlanBox.vue?vue&type=script&lang=js"

import "./ShortPlanBox.vue?vue&type=style&index=0&id=315ea471&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315ea471"]])

export default __exports__